<div class="dashboard-stats">
  <!-- Header -->
  <div class="stats-header">
    <h2><img style="width :80px; display: inline-flex;" [src]="logo"> TrueTech  Dashboard Overview</h2>
    <span class="last-updated" *ngIf="lastUpdated()">
      Updated: {{ lastUpdated() | date:'shortTime' }}
    </span>
  </div>

  <!-- Stats Grid -->
  <div class="stats-grid">
    @for (stat of stats(); track trackByFn($index)) {
      <div class="stat-card" [style.--card-color]="stat.color" 
           (click)="navigateTo(stat.route)" role="button" tabindex="0">
        
        <!-- Decorative Shape -->
        <div class="shape shape-1"></div>
        <div class="shape shape-2"></div>
        
        <!-- Card Content -->
        <div class="card-content">
          <div class="card-icon" [style.background]="stat.color + '20'">
            <span class="icon">{{ stat.icon }}</span>
          </div>
          
          <div class="card-body">
            <h3 class="card-title">{{ stat.title }}</h3>
            <div class="card-value">
              <span *ngIf="!isLoading()" 
                    [appAnimatedCounter]="stat.value" 
                    [duration]="1200">
              </span>
              <span *ngIf="isLoading()" class="loading">...</span>
            </div>
            
            <!-- <div class="card-change" [class.negative]="stat.change < 0">
              <span>{{ stat.change >= 0 ? '↑' : '↓' }}</span>
              <span>{{ getAbs(stat.change) }}% vs last month</span>
            </div> -->
          </div>
        </div>
        
        <!-- Hover Effect -->
        <div class="card-overlay"></div>
      </div>
    }
  </div>

  <!-- Quick Actions -->
  <!-- <div class="quick-actions">
    <button class="action-btn" routerLink="admin/products">
      <span></span> Products
    </button>
    <button class="action-btn" routerLink="admin/orders/">
      <span>📋</span> View Orders
    </button>
     <button class="action-btn" routerLink="/reports">
      <span>📈</span> Generate Report
    </button> 
   </div>
</div> -->